/* eslint-disable */
import { sortBy } from "lodash"


export enum ContentCreatorSort {
    CONTENT_NAME = "CONTENT_NAME",
    UPDATED = "UPDATED",
}

export class ContentCreatorSortUtils {
    static readonly values = [ContentCreatorSort.CONTENT_NAME, ContentCreatorSort.UPDATED]
    static valueOf = (value: string) => ContentCreatorSortUtils.values.find(enumValue => enumValue === value)
    static sort = (value: ContentCreatorSort[]) => sortBy(value, expansion => ContentCreatorSortUtils.values.indexOf(expansion))
}